// extracted by mini-css-extract-plugin
export default {"list-view-item-wrapper":"main-navigation_list-view-item-wrapper__sbeyx","list-view-item":"main-navigation_list-view-item__LFw0M"};